import { Button, Col, Divider, Input, Row, Spinner2, Text } from 'components';
import { Api, currencies } from 'lib';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const OldPricing = ({ filter }) => {
  const [pricing, setPricing] = useState({}),
    isMobile = useSelector((state) => state.appState.isMobile),
    { shoutout, connect } = pricing;

  useEffect(() => {
    getPricing().then();
  }, []);

  async function getPricing() {
    const res = await Api.get('/admin/getPricing');
    if (!res) return;

    /*
      Convert cents to dollars
    */
    setPricing(res);
  }

  function handleChange(type, currency, sub, value) {
    if (sub === 'fee' && value > 100) return;

    setPricing({
      ...pricing,
      [type]: {
        ...pricing[type],
        [currency]: {
          ...pricing[type][currency],
          [sub]: value
        }
      }
    });
  }

  if (isMobile) {
    return (
      <Col center pad="20px" ht="100vh">
        <Text h1>Please visit this screen on a computer browser.</Text>
      </Col>
    );
  }

  async function handleSave() {
    await Api.post('/admin/updatePricing', pricing, 'updatePricing');
  }

  return (
    <Col wid="100%" centerAll flexStart>
      <div className="container">
        <Col centerAll={!pricing && true} wid="100%" between>
          {!Object.keys(pricing).length ? (
            <Spinner2 col="red" />
          ) : (
            <Col flexStart>
              {filter === 'shoutout-to-athletes' && (
                <Col noflex>
                  <Text h3 marg="0 0 10px">
                    Shoutouts
                  </Text>
                  <Divider />

                  <Row marg="15px 0 0">
                    {Object.keys(shoutout).map((currency, i) => {
                      const foundCurrency = currencies.find(
                        (x) => x.value.toLowerCase() === currency
                      );

                      return (
                        <Col marg="0 50px 15px 0" key={i}>
                          <Text h5>{currency.toUpperCase()}</Text>
                          <Input
                            currency
                            title="Price"
                            prefix={foundCurrency.symbol}
                            bg="#fff"
                            placeholder={foundCurrency.symbol}
                            wid="200px"
                            marg="20px 0 0 0"
                            value={shoutout[currency.toLowerCase()].price || 0}
                            onValueChange={(val) =>
                              handleChange('shoutout', currency.toLowerCase(), 'price', val)
                            }
                          />
                          <Input
                            currency
                            bg="#fff"
                            title="Service fee"
                            placeholder="%"
                            marg="15px 0 0"
                            wid="120px"
                            value={shoutout[currency.toLowerCase()].fee || 0}
                            onValueChange={(val) =>
                              handleChange('shoutout', currency.toLowerCase(), 'fee', val)
                            }
                            prefix="%"
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Divider marg="0 0 50px" />
                </Col>
              )}

              {filter === 'one-on-one-connect' && (
                <Col noflex>
                  <Text h3 marg="0 0 10px">
                    Connects
                  </Text>
                  <Divider />
                  <Row marg="15px 0 0">
                    {Object.keys(connect).map((currency, i) => {
                      return (
                        <Col marg="0 50px 0 0" key={i}>
                          <Text h5>{currency.toUpperCase()}</Text>
                          <Input
                            currency
                            bg="#fff"
                            title="Service fee"
                            placeholder="%"
                            marg="15px 0 15px "
                            wid="120px"
                            value={connect[currency.toLowerCase()].fee || 0}
                            onValueChange={(val) =>
                              handleChange('connect', currency.toLowerCase(), 'fee', val)
                            }
                            prefix="%"
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Divider marg="0 0 50px" />
                </Col>
              )}
            </Col>
          )}
        </Col>
        <Col>
          <Row flexEnd ht="100%">
            {Object.keys(pricing).length ? (
              <Button
                big
                text="Save"
                wid="200px"
                marg="0 0 30px"
                onClick={handleSave}
                action="updatePricing"
              />
            ) : null}
          </Row>
        </Col>
      </div>
    </Col>
  );
};

export default OldPricing;
